import { Function } from "../../enums/authorization";

export const SideBarData = [
    {
        routeLink: 'dashboard',
        icon: 'dashboard',
        name: Function.A_P_DASHBOARD,
        label: "Thống kê",
        parentidx: 'tk',
        subItems: [
            {
                routeLink: 'clb',
                icon: 'category',
                name: Function.A_C_DASHBOARDTTCLB,
                label: "Thống kê - CLB"
            },
            {
                routeLink: 'khoi',
                icon: 'summarize',
                name: Function.A_C_DASHBOARDTTKHOI,
                label: "Thống kê - Khối"
            }
        ]
    },
    {
        routeLink: 'user-clbtt-khoi-mng',
        icon: 'groups',
        name: Function.A_C_MNCLBTUOITREKHOI,
        label: "Phật tử CLB Tuổi Trẻ (Khối)"
    },
    {
        routeLink: 'user-clbtt-mng',
        icon: 'groups',
        name: Function.A_C_MNCLBTUOITRE,
        label: "Phật tử CLB Tuổi Trẻ (CLB)"
    },
    {
        routeLink: 'ld-k',
        icon: 'assignment',
        name: Function.A_C_MNCLBTUOITRELDKHOI,
        label: "Quản lý LĐ Khối TT"
       
    },
    {
        routeLink: 'sp-clb',
        icon: 'contact_support',
        name: Function.A_C_SPCLBTTBLD,
        label: "Liên hệ hỗ trợ (BLĐ)"
    },
     {
        routeLink: 'sp-k',
        icon: 'contact_support',
        name: Function.A_C_SPCLBTTKHOI,
        label: "Liên hệ hỗ trợ (Khối)"
    },
];
